module.exports = __webpack_public_path__ + "img/whatsapp-icon.87f5959e.svg";